import React from 'react';
import { PageHero } from '../components/layout/PageHero';
import { DocumentCard } from '../components/procurement/DocumentCard';
import { SectionHeading } from '../components/ui/SectionHeading';
import { procurementDocuments } from '../data/procurement';
export function ProcurementManual() {
  const featuredDoc = procurementDocuments.find(doc => doc.featured);
  const otherDocs = procurementDocuments.filter(doc => !doc.featured);
  return <div data-id="element-767">
      <PageHero title="Procurement Manual" subtitle="Comprehensive guidelines, policies, and procedures for AU procurement" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Procurement'
    }, {
      label: 'Manual'
    }]} data-id="element-768" />

      <div className="max-w-7xl mx-auto px-4 py-12" data-id="element-769">
        {featuredDoc && <div className="mb-12" data-id="element-770">
            <SectionHeading title="Featured Document" subtitle="The complete guide to African Union procurement processes" data-id="element-771" />
            <div className="mt-8" data-id="element-772">
              <DocumentCard title={featuredDoc.title} description={featuredDoc.description} version={featuredDoc.version} date={featuredDoc.date} documentUrl={featuredDoc.documentUrl} featured={true} index={0} data-id="element-773" />
            </div>
          </div>}

        <div data-id="element-774">
          <SectionHeading title="Related Documents" subtitle="Additional guidelines and resources for suppliers and contractors" data-id="element-775" />
          <div className="grid md:grid-cols-2 gap-6 mt-8" data-id="element-776">
            {otherDocs.map((doc, index) => <DocumentCard key={doc.id} title={doc.title} description={doc.description} version={doc.version} date={doc.date} documentUrl={doc.documentUrl} index={index + 1} data-id="element-777" />)}
          </div>
        </div>

        <div className="mt-12 bg-au-green-light rounded-lg p-8" data-id="element-778">
          <h3 className="text-2xl font-bold text-charcoal mb-4" data-id="element-779">Need Help?</h3>
          <p className="text-gray-700 mb-6" data-id="element-780">
            If you have questions about AU procurement procedures or need
            assistance with the documentation, our procurement team is here to
            help.
          </p>
          <div className="flex flex-wrap gap-4" data-id="element-781">
            <a href="mailto:procurement@aucommission.org" className="text-au-green font-medium hover:underline" data-id="element-782">
              procurement@aucommission.org
            </a>
            <span className="text-gray-400" data-id="element-783">|</span>
            <span className="text-gray-700" data-id="element-784">
              +44 (0) 20 4571 0123{' '}
              <span className="text-gray-500" data-id="element-785">(Procurement)</span>
            </span>
          </div>
        </div>
      </div>
    </div>;
}